import { render, staticRenderFns } from "./Immoapp.vue?vue&type=template&id=5a05a6ea&"
import script from "./Immoapp.vue?vue&type=script&lang=js&"
export * from "./Immoapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports